import { render, staticRenderFns } from "./FixedCostAreaDetails.vue?vue&type=template&id=2a4e24cc&scoped=true&"
import script from "./FixedCostAreaDetails.vue?vue&type=script&lang=js&"
export * from "./FixedCostAreaDetails.vue?vue&type=script&lang=js&"
import style0 from "./FixedCostAreaDetails.vue?vue&type=style&index=0&id=2a4e24cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e24cc",
  null
  
)

export default component.exports